import React, { useState, useEffect } from "react";
import DatePicker from 'react-datepicker';
import axios from "axios";
import './TPDSComplianceStatusSummary.css'
import jsPDF from "jspdf";
import { Link } from 'react-router-dom';
import "jspdf-autotable";
import Select from 'react-select';
import { format } from 'date-fns';
import ExcelJS from 'exceljs';
import pds from "./pds.PNG";
const customStyles = {
    control: (provided) => ({
        ...provided,
        borderRadius: "4px",
        padding: "2px",

    }),
    dropdownIndicator: (provided) => ({
        ...provided,

        cursor: "pointer", // Change cursor to indicate it's clickable
    }),
    indicatorSeparator: () => ({
        display: "none", // Hide the default separator

    }),
};
const TPDSComplainStatusSummary = () => {
       const [godownOptions, setGodownOptions] = useState([]); // Store the fetched FPS options
     const [godownId, setGodownId] = useState("");
       const [godownUniqueId, setGodownUniqueId] = useState("");

    const [districtUid, setDistrictUid] = useState(''); // Store districtUid for reports
    const [subDivisionUid, setSubDivisionUid] = useState(''); // Store subdistrictUid for reports
    const [blockUid, setBlockUid] = useState('');
    const [panchayatUid, setPanchayatUid] = useState('');
    const [districtId, setDistrictId] = useState("");
    const [subDivisionId, setSubDivisionId] = useState('');
    const [blockId, setBlockId] = useState('');
    const [districts, setDistricts] = useState([]);
    const [subDivisions, setSubDivisions] = useState([]);
    const [blocks, setBlocks] = useState([]);
    const [panchayatId, setPanchayatId] = useState("");
    const [panchayats, setPanchayats] = useState([]);
    const [fpsId, setFpsId] = useState("");
    const [fpsUniqueId, setFpsUniqueId] = useState("");
    const [fpshops, setFPShops] = useState([]);
    //  const [tableData, setTableData] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [showCalendar, setShowCalendar] = useState(false);
    const [showEndCalendar, setShowEndCalendar] = useState(false);
    const [error, setError] = useState(null);  // Define setError here
    const [isOpen, setIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showDownloadButton, setShowDownloadButton] = useState(false);  // Control visibility of DOWNLOAD PDF button
    const [showTable, setShowTable] = useState(false);
    const [stockData, setStockData] = useState([]);
    // Get the current date and reset time to midnight to avoid time-based issues
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0); // Reset time to midnight
    // Determine the minimum date for the endDate date picker
    const currentYear = currentDate.getFullYear();
    const minStartDate = new Date(currentYear, 0, 1); // January 1st of current year

    const generatePDF = () => {
        const doc = new jsPDF({
            unit: 'mm', // units in mm (millimeters)
            format: [260, 320] // A4 size: 210mm x 297mm (you can customize it to larger size like letter: [216, 279])
        });

        // Set initial font size and add an image
        doc.setFontSize(18);
        doc.addImage(pds, 'PNG', 8, 10, 240, 30);  // Image format: 'PNG'

        const pageWidth = doc.internal.pageSize.width;
        // Set the background color for the title and move it down
        const backgroundYPosition = 40.2; // New y-position for the background fill
        doc.setFillColor(211, 211, 211); // RGB values for 'whitesmoke'
        doc.rect(10, backgroundYPosition, pageWidth - 20, 15, 'F'); // Draw a filled rectangle with the new y-position

        // Set the report title with a styled color
        const title = 'Godown Complain Status Summary Report';
        // Get the page width
        const titleWidth = doc.getTextWidth(title); // Get the width of the title

        // Set title text color to #2a6d8b
        doc.setTextColor(42, 109, 139);  // RGB values for #2a6d8b
        doc.setFontSize(14.4);
        // Increase the y-position to move the title further down
        const titleYPosition = backgroundYPosition + 10; // Adjusted y-position for the title, below the background

        // Define an offset to shift the title to the right (you can adjust this value as needed)
        const xOffset = 15; // Example: shifting the title 20 units to the right

        // Draw the title text in the center of the page
        doc.text(title, (pageWidth - titleWidth) / 2 + xOffset, titleYPosition); // Adjust x-position by adding xOffset


        // Continue with the rest of the report generation logic (fields, values, etc.)

        // Mapping IDs to names for each field
        const district = districts.find(d => String(d.id) === String(districtId));
        const subDivision = subDivisions.find(s => String(s.id) === String(subDivisionId));
        const block = blocks.find(b => String(b.id) === String(blockId));
        const panchayat = panchayats.find(p => String(p.id) === String(panchayatId));
        const fps = fpshops.find(f => String(f.id) === String(fpsId));

        const districtName = district ? district.districtName : 'Not Selected';
        const subDivisionName = subDivision ? subDivision.subDivisionName : 'Not Selected';
        const blockName = block ? block.blockName : 'Not Selected';
        const panchayatName = panchayat ? panchayat.panchayatName : 'Not Selected';
        const fpsName = fps ? fps.fpsId : 'Not Selected';

        // Date formatting (if dates are present)
        const fromDate = startDate ? `${startDate.getDate().toString().padStart(2, '0')}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getFullYear().toString().slice()}` : 'Not Selected';
        const toDate = endDate ? `${endDate.getDate().toString().padStart(2, '0')}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getFullYear().toString().slice()}` : 'Not Selected';

        // Set the font size and text color for the content
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);  // Set text color to black

        // Define startY for positioning text
        let startY = 55.21;  // Starting Y position (distance from top of the page)
        let xPosition = 10;  // Starting X position for the first column

        // Define the space between columns
        const columnSpacing = 80; // Space between columns

        // Draw the first table (District, Sub Division, Block, etc.)
        const tableHeight = 8;  // Row height for each line
        const tableWidth = columnSpacing * 3;  // Table width based on the number of columns

        // Draw table headers with borders between columns
        doc.rect(xPosition, startY, tableWidth, tableHeight);  // Top border of the table

        // Set font to normal for labels (District:, Sub Division:, Block:) 
        doc.setFont("helvetica", "normal");
        doc.setTextColor(0, 0, 0);  // Set text color to black for labels

        // Add labels for the first row
        doc.text("District:", xPosition + 5, startY + 5);
        doc.text("Sub Division:", xPosition + columnSpacing, startY + 5);
        doc.text("Block:", xPosition + columnSpacing * 2.02, startY + 5);

        // Now, set font to bold for dynamic data and change the text color for dynamic values
        doc.setFont("helvetica", "bold");
        doc.setTextColor(0, 0, 0);  // Blue color for dynamic data

        // Add dynamic data in bold and color
        doc.text(districtName, xPosition + 28, startY + 5);  // District name (dynamic)
        doc.text(subDivisionName, xPosition + columnSpacing + 45, startY + 5);  // Sub Division name (dynamic)
        doc.text(blockName, xPosition + columnSpacing * 2.02 + 28, startY + 5);  // Block name (dynamic)

        // Add borders for each column
        doc.line(xPosition + columnSpacing - 3, startY, xPosition + columnSpacing - 3, startY + tableHeight); // Border between columns
        doc.line(xPosition + columnSpacing * 2, startY, xPosition + columnSpacing * 2, startY + tableHeight); // Border between columns

        // Add the first row data
        startY += tableHeight;  // Move down for the next row

        // Draw the second table (Panchayat, FPS ID, Dates)
        const tableHeight2 = 8;  // Row height for each line
        const tableWidth2 = columnSpacing * 3;  // Table width for this table

        startY += tableHeight - 8;  // Add some space between the two tables

        // Draw table headers with borders between columns for the second table
        doc.rect(xPosition, startY, tableWidth2, tableHeight2);  // Top border of the second table

        // Set font to normal for labels (Panchayat, FPS ID) 
        doc.setFont("helvetica", "normal");
        doc.setTextColor(0, 0, 0);  // Set text color to black for labels

        // Add labels for the second row
        doc.text("Panchayat:", xPosition + 5, startY + 5);
        doc.text("FPS ID:", xPosition + columnSpacing, startY + 5);

        // Set font to bold for dynamic data (Panchayat name, FPS ID) and color
        doc.setFont("helvetica", "bold");
        doc.setTextColor(0, 0, 0);  // Green color for dynamic data

        // Add dynamic data in bold and color for Panchayat and FPS ID
        doc.text(panchayatName, xPosition + 28, startY + 5);  // Panchayat name (dynamic)
        doc.text(fpsName, xPosition + columnSpacing + 45, startY + 5);  // FPS ID (dynamic)

        // Add borders for each column in the second table
        doc.line(xPosition + columnSpacing - 3, startY, xPosition + columnSpacing - 3, startY + tableHeight2); // Border between columns

        // Add the second row data
        startY += tableHeight2;  // Move down for the next row

        // Draw the third table (From Date, To Date)
        const tableHeight3 = 8;  // Row height for each line

        startY += tableHeight2 - 8;  // Add some space between tables

        // Draw table headers with borders between columns for the third table
        doc.rect(xPosition, startY, tableWidth2, tableHeight3);  // Top border of the third table

        // Set font to normal for labels (From Date, To Date)
        doc.setFont("helvetica", "normal");
        doc.setTextColor(0, 0, 0);  // Set text color to black for labels

        // Add labels for the third row
        doc.text("From Date:", xPosition + 5, startY + 5);
        doc.text("To Date:", xPosition + columnSpacing, startY + 5);

        // Set font to bold for dynamic data (From Date, To Date) and color
        doc.setFont("helvetica", "bold");
        doc.setTextColor(0, 0, 0);  // Orange color for date fields

        // Add dynamic data in bold and color for From Date and To Date
        doc.text(fromDate, xPosition + 28, startY + 5);  // From Date (dynamic)
        doc.text(toDate, xPosition + columnSpacing + 45, startY + 5);  // To Date (dynamic)

        // Add borders for each column in the third table
        doc.line(xPosition + columnSpacing - 3, startY, xPosition + columnSpacing - 3, startY + tableHeight3); // Border between columns

        // Add the third row data
        startY += tableHeight3;  // Move down for the next row

        // Adjust startY for next section or add more data if necessary
        startY += tableHeight3 + 5;  // Adjust space for next content


        const headers = [
            "S. No.",
            "District",
            "Sub-Division",
            "Block",
            "Panchayat",
            "FPS ID",
            "Date of Inspection",
            "Name of Inspecting Officer",
            // "view"
        ];


        // Example rows for inspection data (replace with actual dynamic data)
        const rows = stockData.map((data, index) => [
            index + 1,
            capitalizeFirstLetter(data.district),
            capitalizeFirstLetter(data.subDivision),
            capitalizeFirstLetter(data.block),
            capitalizeFirstLetter(data.panchayat),
            data.fpsId,
            format(new Date(data.inspectionDate), 'dd-MM-yyyy'),
            formatFullName(data.officerName),

        ]);

        doc.autoTable({
            head: [headers],
            body: rows,
            startY: startY,
            theme: 'grid',
            columnStyles: {
                0: { cellWidth: 12 },
                1: { cellWidth: 23 },
                2: { cellWidth: 30 },
                3: { cellWidth: 25 },
                4: { cellWidth: 35 },
                5: { cellWidth: 30 },
                6: { cellWidth: 28 },
                7: { cellWidth: 30 },
                // 8: { cellWidth: 27 }
            },
            tableWidth: 'auto',  // Adjusts the table width to fit the content
            margin: {
                horizontal: 10,   // Horizontal margin (space on left and right)
                top: 10,          // Top margin
                bottom: 10,  // Bottom margin

            },
            pageBreak: 'auto', // Automatically handle page breaks if the content exceeds one page
            showHead: 'firstPage',  // Display the header only on the first page
            styles: {
                fontSize: 10,  // Set font size for table content
                textColor: 0,  // Text color (black)
            },
            headStyles: {
                fontSize: 8,  // Set a specific font size for headers
                fontStyle: 'bold',  // Make the header text bold
                textColor: [42, 109, 139],  // Set text color to blue (RGB for #2a6d8b)
                fillColor: [211, 211, 211],   // Set background color for header (gray - 'whitesmoke')
            }
        });


        // Save the generated PDF
        //   doc.save('FPS_Complain_Status_Summary_Report.pdf');

    };
    const generateXl = () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Godown Compliance Status Summary');
        const currentDate = new Date();

        // Format the date as DD-MM-YYYY
        const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;

        // Format the time as HH:mm:ss
        const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;

        // Combine both date and time into one string
        const formattedDateTime = `${formattedDate} ${formattedTime}`;
        worksheet.mergeCells('A1:W1'); // Merge cells for the title
        worksheet.getCell('A1').value = `Godown Complain Status Summary Report`; // Add spaces before date to shift it

        worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'left' };
        worksheet.getCell('A1').font = { size: 16, bold: true, color: { argb: 'F7912B' } };  // Text color: Light Steel Blue (ARGB format) black 000000
        worksheet.getCell('A1').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' }  // Background color: Whitesmoke (ARGB format)
        };

        worksheet.mergeCells('A2:W2'); // Merge cells for the title
        worksheet.getCell('A2').value = `Report Date: ${formattedDateTime}`; // Add spaces before date to shift it

        worksheet.getCell('A2').alignment = { vertical: 'middle', horizontal: 'left' };
        worksheet.getCell('A2').font = { size: 11, bold: true, color: { argb: '000000' } };  // Text color: Light Steel Blue (ARGB format) black 000000
        worksheet.getCell('A2').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' }  // Background color: Whitesmoke (ARGB format)
        };

        const fromDate = startDate ? `${startDate.getDate().toString().padStart(2, '0')}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getFullYear().toString().slice()}` : '';
        const toDate = endDate ? `${endDate.getDate().toString().padStart(2, '0')}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getFullYear().toString().slice()}` : '';
       
        worksheet.mergeCells('A3:D3'); // Merge cells for the title
        worksheet.getCell('A3').value = `From Date: ${fromDate}                  To Date: ${toDate}`; // Add spaces before date to shift it

        worksheet.getCell('A3').alignment = { vertical: 'middle', horizontal: 'left' };
        worksheet.getCell('A3').font = { size: 11, bold: true, color: { argb: '000000' } };  // Text color: Light Steel Blue (ARGB format) black 000000
        worksheet.getCell('A3').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' }  // Background color: Whitesmoke (ARGB format)
        };
        // Define the header row
        worksheet.addRow(['S.No', 'District', 'Sub Division', 'Block', 'Panchayat', 'Godown ID','Godown Name', 'Date Of Inspection ', 'Assistant Manager Name', 'Assistant Manager Year of Post', 'Address ', 'capacity', 'Assistant Manager Godowns', 'Godown status', 'Assistant Manager Present', 'Quality Controller Name','Quality Controller Year of Post',"Quality Controller Present","Quality Controller Godown", "Deo Name","deo Present","inRegAvail",]);

        // Apply header style: bold, size 12, and orange background
        worksheet.getRow(4).font = { bold: true, size: 12 };
        worksheet.getRow(4).alignment = { horizontal: 'center' }; // Center alignment

        // Apply background color to the first 6 cells of the header row
        for (let col = 1; col <= 22; col++) {
            const cell = worksheet.getCell(4, col); // Get each cell in the first row (header)
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFA500' }  // Orange background color
            };
            // Apply font styling: bold and size 12
            cell.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
            // Add border to header cells
            cell.border = {
                top: { style: 'thin', color: { argb: '000000' } },
                left: { style: 'thin', color: { argb: '000000' } },
                bottom: { style: 'thin', color: { argb: '000000' } },
                right: { style: 'thin', color: { argb: '000000' } }
            };
        }

        // Adjust column widths
        worksheet.columns = [
            { key: 'A', width: 10 },  // Column A width
            { key: 'B', width: 20 },  // Column B width
            { key: 'C', width: 25 },  // Column C width
            { key: 'D', width: 25 },  // Column D width
            { key: 'E', width: 35 },  // Column E width
            { key: 'F', width: 25 },  // Column F width
            { key: 'G', width: 25 },  // Column G width (Date of Inspection)
            { key: 'H', width: 35 },  // Column H width
            { key: 'I', width: 35 },  // Column I width (License Valid Till)
            { key: 'J', width: 35 },
            { key: 'k', width: 35 },
            { key: 'L', width: 35 },
            { key: 'M', width: 35 },
            { key: 'N', width: 55 },
            { key: 'O', width: 35 },
            // { key: 'P', width: 35 },
            { key: 'Q', width: 35 },
            { key: 'R', width: 35 },
            { key: 'S', width: 35 },
            { key: 'T', width: 35 },
            { key: 'U', width: 35 },
            { key: 'V', width: 55 },
            { key: 'W', width: 55 },
            // { key: 'X', width: 35 },
            // { key: 'Y', width: 35 },
            // { key: 'z', width: 35 },
        ];

        // Process stockData and map responses based on FPS ID
        stockData.forEach((data, index) => {
            const questionSurveys = data.questionSurveys || [];

            // Map questionSurveys responses
            const getResponse = (questionUid) => {
                const survey = questionSurveys.find(s => s.question?.questionUid === questionUid);
                return survey ? survey.response : 'No Response';
            };

            // Add data row for each FPS ID
            const row = [
                index + 1,  // S.No
                capitalizeFirstLetter(data.districtName),  // District
                capitalizeFirstLetter(data.subDivisionName),  // Sub Division
                capitalizeFirstLetter(data.blockName),  // Block
                capitalizeFirstLetter(data.panchayatName),  // Panchayat
                data.godownId,  // FPS ID (aligned right)
                 data.godownName,
                format(new Date(data.startTime), 'dd-MM-yyyy'),  // Date of Inspection (aligned right)
                formatFullName(data.amName),  // Officer Name
                data.amYop,
                data.address,
                data.capacity,
                data.amGodowns,
                data.godownOpen,
                data.amPresent,  
                data.qcName,
                data.qcYop,
                data.qcPresent,
                data.qcGodowns,
                data.deoName,
                data.deoPresent,
                data.inRegAvail 

            ];

            // Add the row to the worksheet
            const rowIndex = index + 3; // Excel row starts from 1, but header is row 1
            const addedRow = worksheet.addRow(row);

            [6, 7, 8,10,12, 17,21, 22].forEach((colIndex) => {
                addedRow.getCell(colIndex).alignment = { horizontal: 'right' };
            });
            addedRow.getCell(1).alignment = { horizontal: 'center' };
            
          
        });

        // Save the file (Excel)
        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/octet-stream' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'Godown_Compliance_Status_Summary_Report.xlsx';
            link.click();
        });
    };

    // Helper function to format numbers to two decimal places
    // Helper function to format numbers to two decimal places and add commas for thousands
    function formatToTwoDecimals(value) {
        const num = parseFloat(value);

        if (isNaN(num)) {
            return value; // Return the original value if it's not a valid number
        }

        // Format the number to 2 decimal places and add commas for thousands
        return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }



    const handleStartDateChange = (date) => {
        setStartDate(date);       // Set the selected start date
        setEndDate('');           // Clear the end date when start date changes
        setShowCalendar(false);   // Hide the calendar after selection
        setShowTable(false);
    };


    const handleEndDateIconClick = () => {
        // Only show the calendar for endDate if startDate is selected
        if (startDate) {
            setShowEndCalendar(true);
        }
    };
    // Handle the end date change
    const handleEndDateChange = (date) => {
        setEndDate(date);
        setShowEndCalendar(false);
        setShowTable(false);
    };

    // Token you provided (for testing purposes)
    const token = `${process.env.REACT_APP_AFTER_TOKEN}`;
    const baseUrl = `${process.env.REACT_APP_AUDIT_API_URL}/api`;
    const godownUrl = `${process.env.REACT_APP_GODOWN_API_URL}/api`;
    useEffect(() => {
        if (token) {
            axios
                .get(`${baseUrl}/districts?pagination[pageSize]=50`, {
                    headers: { Authorization: `Bearer ${token}` },
                })
                .then((response) => {
                    if (response.data && response.data.data && Array.isArray(response.data.data)) {

                        setDistricts(response.data.data);
                        const updatedDistricts = [
                            { district: 'All', districtName: 'All Districts', districtUid: null }, // 'All' option
                            ...response.data.data
                        ];

                        setDistricts(updatedDistricts); // Set the updated districts with 'All'
                    } else {
                        setError("Invalid response format");
                    }


                })
                .catch((error) => {
                    setError("Error fetching districts");
                    console.error("Error fetching districts:", error);
                });
        } else {
            setError("No token found. Please log in.");
        }
    }, [token]);

    const fetchSubDivisions = async (districtId) => {
        if (districtId) {
            try {
                const response = await axios.get(`${baseUrl}/sub-divisions?filters[district][id][$eq]=${districtId}&pagination[pageSize]=50`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setSubDivisions(response.data.data || []);
            } catch (error) {
                setError("Error fetching sub-divisions");
            }
        } else {
            setSubDivisions([]);
        }
    };



    const fetchBlocks = async (subDivisionId) => {
        if (subDivisionId) {
            try {
                const response = await axios.get(`${baseUrl}/blocks?filters[subDivision][id][$eq]=${subDivisionId}&pagination[pageSize]=50`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setBlocks(response.data.data || []);
            } catch (error) {
                setError("Error fetching blocks");
            }
        } else {
            setBlocks([]);
        }
    };




    const fetchPanchayats = async (blockId) => {
        if (blockId) {
            try {
                const response = await axios.get(`${baseUrl}/panchayats?filters[block][id][$eq]=${blockId}&pagination[pageSize]=50`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setPanchayats(response.data.data || []);
            } catch (error) {
                setError("Error fetching panchayats");
            }
        } else {
            setPanchayats([]);
        }
    };

    const fetchGodownOptions = async () => {
        setIsLoading(true); // Show loading indicator

        // Construct request payload
        const requestData = {};

        if (districtUid) {
            requestData.district = districtUid;
        }
        if (subDivisionUid) {
            requestData.subDivision = subDivisionUid;
        }
        if (blockUid) {
            requestData.block = blockUid;
        }
        if (panchayatUid) {
            requestData.panchayat = panchayatUid;
        }

        try {
            const response = await axios.post(`${godownUrl}/get-godown-by-filters`, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (response.data && response.data.data) {
                setGodownOptions(response.data.data); // Set the fetched FPS options
            } else {
                setGodownOptions([]);
                setError("No FPS data found for the selected filters.");
            }
        } catch (error) {
            setError("Error fetching FPS options.");
            console.error('Error fetching FPS options:', error);
        } finally {
            setIsLoading(false); // Hide loading indicator
        }
    };

    useEffect(() => {
        // Fetch FPS options whenever the filters change
        if (districtUid || subDivisionUid || blockUid || panchayatUid) {
            fetchGodownOptions();
        }
    }, [districtUid, subDivisionUid, blockUid, panchayatUid]);

    const handleFpsSelection = (selectedFpsId) => {
        setFpsId(selectedFpsId); // Store the selected FPS ID
    };
    const handleDistrictChange = (selectedOption) => {
        const selectedDistrictId = selectedOption ? selectedOption.value : '';  // districtId for filtering
        const selectedDistrictUid = selectedOption ? selectedOption.districtUid : '';  // districtUid for reports

        //console.log('Selected District ID (for filtering):', selectedDistrictId);  // for filtering
        // console.log('Selected District UID (for report generation):', selectedDistrictUid);  // for report generation

        // Set both districtId (for filtering) and districtUid (for report generation)
        setDistrictId(selectedDistrictId);  // For filtering
        setDistrictUid(selectedDistrictUid);  // For report generation
        setSubDivisionUid('');  // Clear subDivisionUid
        setPanchayatUid('');  // Clear panchayatUid
        setBlockUid('');
        setGodownUniqueId('');
        setGodownId('');  // Reset godown ID
        // Reset other state
        setSubDivisionId('');
        setBlockId('');
        setPanchayatId('');

        setFPShops([]);
        setPanchayats([]);
        setBlocks([]);
        setShowTable(false);

        // Fetch subdivisions based on districtId (for filtering)
        fetchSubDivisions(selectedDistrictId);
    };


    const handleSubDivisionChange = (selectedOption) => {
        const selectedId = selectedOption ? selectedOption.value : '';
        const selectdSubDivisionUid = selectedOption ? selectedOption.subDivisionUid : " ";
        // console.log('Selected Subdivision:', selectedId);
        // console.log('Selected selectdSubDivisionUid:', selectdSubDivisionUid);
        // Reset everything except block
        setSubDivisionUid(selectdSubDivisionUid)
        setSubDivisionId(selectedId);
        // setSubDivisionUid('');  // Clear subDivisionUid
        setPanchayatUid('');  // Clear panchayatUid
        setBlockUid('');
     
        setBlockId('');  // Reset block
        setPanchayatId('');  // Reset panchayat
        setGodownUniqueId('');
        setGodownId('');  // Reset godown ID
        setFPShops([]);  // Clear FPS shops 
        setPanchayats([])  //it is not actved panchayats without selecting
        setBlocks([]) //it is not actved block  without selecting
        setShowTable(false);  // Reset table visibility
        fetchBlocks(selectedId);  // Fetch blocks based on the selected subdivision
    };

    const handleBlockChange = (selectedOption) => {

        const selectedId = selectedOption ? selectedOption.value : '';
        const selectedBlockUid = selectedOption ? selectedOption.blockUid : '';
        // console.log('Selected Block:', selectedId);
        // console.log('Selected BlockUid:', selectedBlockUid);
        // Reset everything except panchayat
        setBlockId(selectedId);
        //  console.log('Selected BlockUid:', selectedBlockUid);
        setBlockUid(selectedBlockUid);
        setPanchayatUid('');  // Clear panchayatUi
        setGodownUniqueId('');
        setGodownId('');  // Reset godown ID
        setPanchayatId('');  // Reset panchayat
        setFPShops([]);  // Clear FPS shops without selecting
        setPanchayats([])  //it is not actved panchayats  without selecting
        setShowTable(false);  // Reset table visibility
        fetchPanchayats(selectedId);  // Fetch panchayats based on the selected block
    };

    const handlePanchayatChange = (selectedOption) => {
        const selectedId = selectedOption ? selectedOption.value : '';
        const selectedpanchayatUid = selectedOption ? selectedOption.panchayatUid : '';
        // console.log('Selected Panchayat:', selectedId);
        // console.log("selected panUid", selectedpanchayatUid);
        setPanchayatUid(selectedpanchayatUid);
        // Reset only FPS ID, as panchayat is selected


      
        setPanchayatId(selectedId);
        setGodownUniqueId('');
        setGodownId('');  // Reset godown ID
        setFPShops([]);  // Clear FPS shops not accepting fps without selecting
        setShowTable(false);  // Reset table visibility
        //  fetchFPShops(selectedId);  // Fetch FPS shops based on the selected panchayat
    };

    const handleGodownId = (selectedOption) => {
        const selectedGodownId = selectedOption ? selectedOption.value : '';
        const selectedGodownUniqueId = selectedOption ? selectedOption.label : '';

        console.log('Selected godo:', selectedGodownId);
        console.log('unique normal ', selectedGodownUniqueId)
        setGodownId(selectedGodownId);  // Save the selected FPS ID
        setGodownUniqueId(selectedGodownUniqueId);  // Save the selected FPS Unique ID
        //setGodownUniqueId('');
        // setFpsId('');  
        setShowTable(false);  // Show the table after FPS ID is selected
    };

    const handleClear = () => {
        setGodownId('');
        setDistrictUid(null);
        setDistrictId('');
        setSubDivisionId('');
        setBlockId('');
        setPanchayatId('');
        setStartDate('');
        setEndDate('');
        setShowDownloadButton(false);
        setShowTable(false);
    };

    const handleGenerateReport = () => {

        // Case 3: Ensure startDate is before endDate if both are selected (basic validation)
        if (startDate && endDate && startDate > endDate) {
            setError("Start date cannot be later than end date.");
            alert("Start date cannot be later than end date.");
            return;
        }

        // Start loading
        setIsLoading(true);
        setStockData([]);  // Clear previous stock data

        // Prepare request data
        const requestData = {};

        // Add startDate and endDate to the requestData if available
        if (startDate) {
            requestData.startDate = formatDate(startDate);
        }

        if (endDate) {
            requestData.endDate = formatDate(endDate);
        }

        // Add districtId to the requestData if selected
        // Add districtId to the requestData if selected (only if needed)
        if (districtUid) {
            requestData.districtUid = districtUid;
            requestData.surveyType = "2";
        } else if (!districtUid && !fpsId && !fpsUniqueId) {
            // If no fpsId and no districtUid, set default as "All"
            requestData.districtUid = "All";
            requestData.surveyType = "2";
        }

        // Add other optional parameters like subDivision, block, panchayat, fpsId
        if (subDivisionUid) {
            requestData.subDivisionUid = subDivisionUid;
        }

        if (blockUid && blockUid!== "") {
            requestData.blockUid = blockUid;
        }

        if (panchayatUid && panchayatUid!== "") {
            requestData.panchayatUid = panchayatUid;
        }
        if (godownUniqueId) {
            requestData.godownId = godownUniqueId;  // Use godownUniqueId if it's available
        } else if (godownId) {
            requestData.godownId = godownId;  // Otherwise, use godownId
        }

        // console.log(requestData);  // Log the request data for debugging



        // Make the POST request to fetch the report
        axios
            .post(`${process.env.REACT_APP_API_BASE_URL}/reports/godown-compliance-status`, requestData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json', // Ensure content type is set
                },
            })
            .then((response) => {
                setIsLoading(false);
                if (response.data && response.data.length > 0) {
                    setStockData(response.data);  // Access the 'data' array in the response
                    setShowDownloadButton(true);
                    setShowTable(true);
                } else {
                    setStockData([]);
                    setError("No data available for the selected date range.");
                    setShowDownloadButton(false);
                    setShowTable(true);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setError("Error fetching report.");
                console.error('Error fetching report:', error);
                setShowDownloadButton(false); // Hide download button if there was an error
                setShowTable(true); // Show the table even if there's an error
            });

        setShowTable(true);  // This will show the table
        setShowDownloadButton(true);

    };
    const sortData = (data) => {
        return data.sort((a, b) => {
            const districtA = a.districtName || '';
            const districtB = b.districtName || '';
            const subDivisionA = a.subDivisionName || '';
            const subDivisionB = b.subDivisionName || '';
            const blockA = a.blockName || '';
            const blockB = b.blockName || '';
            const panchayatA = a.panchayatName || '';
            const panchayatB = b.panchayatName || '';

            // Sorting order: first district, then sub-division, then block, and finally panchayat
            if (districtA < districtB) return -1;
            if (districtA > districtB) return 1;
            if (subDivisionA < subDivisionB) return -1;
            if (subDivisionA > subDivisionB) return 1;
            if (blockA < blockB) return -1;
            if (blockA > blockB) return 1;
            if (panchayatA < panchayatB) return -1;
            if (panchayatA > panchayatB) return 1;
            return 0;
        });
    };

    // Sorted data before rendering
    const sortedStockData = sortData(stockData);

    const capitalizeFirstLetter = (text) => {
        // Check if the text is defined and not empty
        if (text && typeof text === 'string') {
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        }
        return ''; // Return an empty string if text is undefined or not a string
    };
    const formatFullName = (text) => {
        // Check if the text is defined and not empty
        if (text && typeof text === 'string') {
            return text
                .split(' ') // Split the string by spaces into words
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter of each word
                .join(' '); // Join the words back into a single string with spaces
        }
        return ''; // Return an empty string if text is undefined or not a string
    };
    // Controlled dropdown open/close
    const toggleDropdown = () => {
        setIsOpen((prevState) => !prevState);
    };

    const formatDate = (date) => {
        if (!date) return null;
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
    };
    // const getFirstDataByQuestionUid = (uid) => {
    //     // Ensure that tableData is an array
    //     if (Array.isArray(stockData)) {
    //         // Filter the data based on the questionUid within the questionSurveys
    //         const filteredData = stockData.filter(item => {
    //             // Check if any of the questionSurveys have a matching questionUid
    //             return item.questionSurveys.some(survey => survey.question.questionUid === uid);
    //         });

    //         // Return the first matching data, or null if no match found
    //         return filteredData.length > 0 ? filteredData[0] : null;
    //     } else {
    //         console.error("tableData is not an array:", stockData);
    //         return null;
    //     }
    // };

    // const shopDetailsData = getFirstDataByQuestionUid("1");
    // const questionSurveys = shopDetailsData ? shopDetailsData.questionSurveys : [];
    // const geoTaggedPhotos = shopDetailsData ? shopDetailsData.geoTaggedPhotos : [];
    // const benQuestionSurveys = shopDetailsData ? shopDetailsData.benQuestionSurveys : [];


    return (
        <div className="complainstatusGoDown">


            <div className="complainstatusGoDown-1">
                <div className="complainstatusGoDown-card-head">TPDS Godown Compliance Status Summary </div>
                <div className='GoDown-whole-div'>
                    <div className="complainstatusGoDown-main">
                        <div className="complainstatusGoDown-group">
                            <label htmlFor="district" >
                                <span className="asterisk">*</span>District
                            </label>
                            <Select
                                className="complainstatusGoDown-search-select"
                                id="district"
                                // Ensure you pass the selected option as an object with value and label
                                value={districts.find((dist) => dist.id === districtId) ? {
                                    value: districts.find((dist) => dist.id === districtId).id,
                                    label: capitalizeFirstLetter(districts.find((dist) => dist.id === districtId).districtName)
                                } : null}
                                onChange={handleDistrictChange}  // Handle the selection change
                                options={districts
                                    .sort((a, b) => a.districtName.localeCompare(b.districtName))  // Sort by districtName alphabetically
                                    .map((dist) => ({
                                        value: dist.id,
                                        label: capitalizeFirstLetter(dist.districtName),
                                        districtUid: dist.districtUid,
                                    }))
                                }
                                placeholder="Select a district"
                                isSearchable // Enable search in the dropdown
                                styles={customStyles} // Apply custom styles here
                                required
                                isOpen={isOpen}
                                onMenuOpen={toggleDropdown} // Trigger dropdown open
                                onMenuClose={toggleDropdown} // Trigger dropdown close
                                components={{
                                    DropdownIndicator: () => (
                                        <div onClick={toggleDropdown} style={{ cursor: "pointer", marginRight: "10px" }}>
                                            <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange' %3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E" alt="Dropdown" style={{ width: "20px", height: "20px" }} />
                                        </div>
                                    ),
                                }}
                            />
                        </div>


                        <div className="complainstatusGoDown-group">
                        <label htmlFor="fpsId">Godown ID</label>
                            {districtId || districtUid ? (
                                <Select
                                    className="complainstatusGoDown-search-select"
                                    id="fps"
                                    value={godownId ? {
                                        value: godownId,
                                        label: godownOptions.find((godo) => godo.id === godownId)?.godownId  // Use godownId for label
                                    } : null}
                                    onChange={handleGodownId}
                                    options={godownOptions.sort((a, b) => a.godownId.localeCompare(b.godownId))
                                        .map((godo) => ({
                                            value: godo.id,
                                            label: godo.godownId,  // Display the godownId as label
                                            godownUniqueId: godo.godownUniqueId,  // Include godownUniqueId for report generation
                                        }))}
                                    placeholder="Select Godown Shop"
                                    isSearchable
                                    styles={customStyles}
                                    required
                                    isOpen={isOpen}
                                    onMenuOpen={toggleDropdown}
                                    onMenuClose={toggleDropdown}
                                    components={{
                                        DropdownIndicator: () => (
                                            <div onClick={toggleDropdown} style={{ cursor: 'pointer', marginRight: '10px' }}>
                                                <img
                                                    src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E"
                                                    alt="Dropdown"
                                                    style={{ width: '20px', height: '20px' }}
                                                />
                                            </div>
                                        ),
                                    }}
                                />
                            ) : (
                                <input className="complainstatusGoDown-search-select-1"
                                    type="text"
                                    placeholder="Enter Godown ID"
                                    value={godownId}
                                    onChange={(e) => setGodownId(e.target.value)}
                                // style={{ padding: '5px' }}
                                />
                            )}
                        </div>

                        <div className="complainstatusGoDown-group-3">
                            {/* Conditionally Render GET REPORT Button */}
                            <div className="forGoDown-mobile">

                                <div className="complainstatusGoDown-group-3-clear">
                                    <button className="complainstatusGoDown-button" onClick={handleClear}
                                        disabled={
                                            // Button is disabled if no districtId or fpsId is provided AND no startDate and endDate are provided
                                            !(fpsId || (districtUid && startDate && endDate) || (districtUid === null && startDate && endDate))
                                        }
                                    >CLEAR
                                    </button>
                                </div>
                                <div className="complainstatusGoDown-group-3-clear">
                                    <button
                                        className="complainstatusGoDown-button"
                                        onClick={handleGenerateReport}
                                        disabled={
                                            // Button is disabled if no districtId or fpsId is provided AND no startDate and endDate are provided
                                            !(fpsId || (districtUid && startDate && endDate) || (districtUid === null && startDate && endDate))
                                        }  // Disable if any field is not selected
                                    >
                                        GENERATE REPORT
                                    </button>
                                </div>


                                {/* Conditionally Render DOWNLOAD PDF Button */}
                                {(fpsId || (districtUid && startDate && endDate) || (districtUid === null && startDate && endDate)) && showDownloadButton && showTable && (
                                    <div className="complainstatusGoDown-group-3-clear">
                                        {/* <button onClick={generatePDF} className="complainstatus-button">
                                        DOWNLOAD PDF
                                    </button> */}
                                        <button onClick={generateXl} className="complainstatusGoDown-button">
                                            DOWNLOAD XLSX
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>

                    </div>

                    {/* <div className="complainstatusGoDown-block-2"> */}
                        {/* <div className="complainstatusGoDown-group-2">
                            <label htmlFor="panchayat" className="district-items-testing-stock">Panchayat</label>
                            <Select
                                className="complainstatusGoDown-search-select"
                                id="panchayat"
                                value={panchayatId ? {
                                    value: panchayatId,
                                    label: capitalizeFirstLetter(panchayats.find((p) => p.id === panchayatId)?.panchayatName)
                                } : null}
                                onChange={handlePanchayatChange}
                                options={panchayats.sort((a, b) => a.panchayatName.localeCompare(b.panchayatName))
                                    .map((p) => ({
                                        value: p.id,
                                        label: capitalizeFirstLetter(p.panchayatName,),
                                        panchayatUid: p.panchayatUid,
                                    }))}
                                placeholder="Select Panchayat"
                                isSearchable
                                styles={customStyles}
                                required
                                isOpen={isOpen}
                                onMenuOpen={toggleDropdown}
                                onMenuClose={toggleDropdown}
                                components={{
                                    DropdownIndicator: () => (
                                        <div onClick={toggleDropdown} style={{ cursor: 'pointer', marginRight: '10px' }}>
                                            <img
                                                src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E"
                                                alt="Dropdown"
                                                style={{ width: '20px', height: '20px' }}
                                            />
                                        </div>
                                    ),
                                }}
                            />
                        </div> */}

                        {/* <div className="complainstatusGoDown-group-2"> */}
                            {/* <label htmlFor="fpsId">Godown ID</label>
                            {districtId || districtUid ? (
                                <Select
                                    className="complainstatusGoDown-search-select"
                                    id="fps"
                                    value={godownId ? {
                                        value: godownId,
                                        label: godownOptions.find((godo) => godo.id === godownId)?.godownId  // Use godownId for label
                                    } : null}
                                    onChange={handleGodownId}
                                    options={godownOptions.sort((a, b) => a.godownId.localeCompare(b.godownId))
                                        .map((godo) => ({
                                            value: godo.id,
                                            label: godo.godownId,  // Display the godownId as label
                                            godownUniqueId: godo.godownUniqueId,  // Include godownUniqueId for report generation
                                        }))}
                                    placeholder="Select Godown Shop"
                                    isSearchable
                                    styles={customStyles}
                                    required
                                    isOpen={isOpen}
                                    onMenuOpen={toggleDropdown}
                                    onMenuClose={toggleDropdown}
                                    components={{
                                        DropdownIndicator: () => (
                                            <div onClick={toggleDropdown} style={{ cursor: 'pointer', marginRight: '10px' }}>
                                                <img
                                                    src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E"
                                                    alt="Dropdown"
                                                    style={{ width: '20px', height: '20px' }}
                                                />
                                            </div>
                                        ),
                                    }}
                                />
                            ) : (
                                <input className="complainstatusGoDown-search-select-1"
                                    type="text"
                                    placeholder="Enter Godown ID"
                                    value={godownId}
                                    onChange={(e) => setGodownId(e.target.value)}
                                 style={{ padding: '5px' }}
                                />
                            )} */}
                        {/* </div> */}

                        {/* <div className="complainstatusGoDown-group-2">

                        </div> */}

                    {/* </div> */}

                    <div className="complainstatusGoDown-block-3">
                        <div className="complainstatusGoDown-group-3">
                            <label htmlFor="startDate" ><span className="asterisk">*</span>From Date</label>
                            <div className="dates-setting-stock-complainsg">
                                <input
                                    type="text"
                                    id="startDate"
                                    className="complainstatusGoDown-input"
                                    value={startDate ? format(startDate, 'dd-MM-yyyy') : ''}
                                    readOnly
                                    onClick={() => setShowCalendar(true)}
                                />
                                <div className="complainstatusGoDown-icon" onClick={() => setShowCalendar(true)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="orange">
                                        <path d="M7 10l5 5 5-5z" />
                                    </svg>
                                </div>
                                {showCalendar && (
                                    <DatePicker
                                        selected={startDate}
                                        onChange={handleStartDateChange}
                                        onClickOutside={() => setShowCalendar(false)}
                                        inline
                                        minDate={minStartDate} // From January 1st of current year
                                        maxDate={currentDate} // Today
                                    />
                                )}
                            </div>
                        </div>


                        <div className="complainstatusGoDown-group-3">
                            <label htmlFor="startDate" ><span className="asterisk">*</span>To Date</label>
                            <div className="dates-setting-stock-complainsg">
                                <input
                                    type="text"
                                    id="startDate"
                                    className="complainstatusGoDown-input"
                                    value={endDate ? format(endDate, 'dd-MM-yyyy') : ''}
                                    readOnly
                                    onClick={() => setShowEndCalendar(true)}
                                    disabled={!startDate}
                                />
                                <div className="complainstatusGoDown-icon" onClick={handleEndDateIconClick}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="orange">
                                        <path d="M7 10l5 5 5-5z" />
                                    </svg>
                                </div>
                                {showEndCalendar && (
                                    <DatePicker
                                        selected={endDate}


                                        onChange={handleEndDateChange}
                                        onClickOutside={() => setShowEndCalendar(false)}
                                        // minDate={minEndDate}  // Disable dates before startDate
                                        inline
                                        minDate={startDate} // End date can't be before the start date
                                        maxDate={currentDate} // End date can't be after today

                                    />
                                )}
                            </div>
                        </div>

                        <div className="complainstatusGoDown-group-3">
                            {/* Conditionally Render GET REPORT Button */}
                            <div className="forGoDown-mobile">

                                {/* <div className="complainstatusGoDown-group-3-clear">
                                    <button className="complainstatusGoDown-button" onClick={handleClear}
                                        disabled={
                                            // Button is disabled if no districtId or fpsId is provided AND no startDate and endDate are provided
                                            !(fpsId || (districtUid && startDate && endDate) || (districtUid === null && startDate && endDate))
                                        }
                                    >CLEAR
                                    </button>
                                </div> */}
                                {/* <div className="complainstatusGoDown-group-3-clear">
                                    <button
                                        className="complainstatusGoDown-button"
                                        onClick={handleGenerateReport}
                                        disabled={
                                            // Button is disabled if no districtId or fpsId is provided AND no startDate and endDate are provided
                                            !(fpsId || (districtUid && startDate && endDate) || (districtUid === null && startDate && endDate))
                                        }  // Disable if any field is not selected
                                    >
                                        GENERATE REPORT
                                    </button>
                                </div> */}


                                {/* Conditionally Render DOWNLOAD PDF Button */}
                                {/* {(fpsId || (districtUid && startDate && endDate) || (districtUid === null && startDate && endDate)) && showDownloadButton && showTable && (
                                    <div className="complainstatusGoDown-group-3-clear">
                                        
                                        <button onClick={generateXl} className="complainstatusGoDown-button">
                                            DOWNLOAD XLSX
                                        </button>
                                    </div>
                                )} */}
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="complainstatusGoDown-repo">

                <table className="complainstatusGoDown-table">
                    <thead>
                        <tr>
                            <th>S. No</th>
                            <th>District</th>
                            <th>Sub- Division</th>
                            <th>Block</th>
                            <th>Panchayat</th>
                            <th>Godown ID</th>
                            <th>Godown Name</th>
                            <th>Date of Inspection</th>
                            <th>Name of Inspecting Officer</th>
                            {/* <th>View</th> */}
                        </tr>
                    </thead>
                    {showTable && (
                        <tbody>
                            {isLoading ? (
                                <tr>
                                    <td colSpan="14" style={{ textAlign: 'center' }}>
                                        Loading...
                                    </td>
                                </tr>
                            ) :
                                sortedStockData && sortedStockData.length > 0 ? (
                                    sortedStockData.map((data, index) => (
                                        <tr key={data.fpsId}>
                                            <td>{index + 1}</td>
                                            <td>{capitalizeFirstLetter(data.districtName || 'N/A')}</td>
                                            <td>{capitalizeFirstLetter(data.subDivisionName || 'N/A')}</td>
                                            <td>{capitalizeFirstLetter(data.blockName || 'N/A')}</td>
                                            <td>{capitalizeFirstLetter(data.panchayatName || 'N/A')}</td>
                                            <td>{data.godownId || 'N/A'}</td>
                                            <td>{data.godownName || 'N/A'} </td>
                                            <td>{format(new Date(data.startTime), 'dd-MM-yyyy')} </td> {/* Use custom formatDate function */}
                                            <td>{formatFullName(data.officerName || 'N/A')}</td>
                                            {/* <td>{data.village || 'N/A'}</td> */}

                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="9" style={{ textAlign: 'center', color: 'red' }}>
                                            No Data Available
                                        </td>
                                    </tr>
                                )}
                        </tbody>
                    )}

                </table>




            </div>

        </div>
    );
}
export default TPDSComplainStatusSummary;